import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './PopoverContent.module.css';
import React from 'react';

const PopoverContent = ({ fileContent }) => {
  return (
    <>
      <div className={styles['popover_wrapper']}>
        <div className={styles['config_icon']}>
          <InfoCircleOutlined style={{ color: '#1890ff', fontSize: '1.1em' }} />
        </div>
        <div className={styles['config_info']}>
          <div className={styles['config_info_title']}>{fileContent.name}</div>
          <div className={styles['config_info_content']}>{fileContent.description}</div>

          <div className={styles['list']}>
            <b className={styles['config_info_sub_title']}>{fileContent.action}</b>
            <ol className={styles['config_info_content']} type="1">
              {fileContent.steps.map((step, index) => (
                <li key={index}>
                  {index + 1}. {step}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopoverContent;
